module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.f4769f9bdb7466be6508.eot";


//////////////////
// WEBPACK FOOTER
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/assets/bootstrap/fonts/glyphicons-halflings-regular.eot
// module id = ../../../../../src/assets/bootstrap/fonts/glyphicons-halflings-regular.eot
// module chunks = styles